import { logger } from '@/services/logger.service';
import { SipJs } from '@/services/sip-js.service';
import { IAgentApi } from '@/services/solgari-api/interfaces/agent.interface';

export const getUriFromAgent = (agent: IAgentApi): string => {
  if (!agent.extensionId) {
    logger.error('There is no extension in agent');
  }

  const uriByAgent = SipJs.authData.uri.replace(
    /sip:.+@/,
    `sip:${agent.extensionId}@`,
  );

  return uriByAgent;
};
